import React, { useEffect, useState } from 'react'
import { Button, Col, Image, Row, Table } from 'react-bootstrap'
import { BsPlusLg } from 'react-icons/bs'
import { getEducationAPI } from '../../../../services/education'
import CreateEducationHistory from '../education-history-create'
import EditEducationHistory from '../education-history-edit'
import { useSearchParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import CheckUserAdmin from '../../../../helper/check-user-admin'
import { RecruitsEducationsAPI } from '../../../../services/recruit'
import Autocomplete from '../../../custom/autocomplete'
import { useDebounce } from '@react-hook/debounce'
import UserecruitsAe from '../../../../hooks/use-recruit-ae'
import iconEdit from '../../../../images/Edit.svg'
import FileEducationTablePIM from './file-education-table'
import ModalAddAeEducation from '../modal-add-ae-education'
import { v4 as uuidv4 } from 'uuid'

function EducationHistory() {
  const { profile } = useSelector((state) => state.profileReducer)

  const orgId = profile?.orgId
  const code = profile?.code

  const [dataTable, setDataTable] = useState([])
  const [showCreate, setShowCreate] = useState(false)
  const [showEdite, setShowEdite] = useState(false)
  const [showAE, setShowAE] = useState(false)
  const [isSave, setIsSave] = useState(false)
  const [detailTable, setDetailTable] = useState()

  useEffect(() => {
    if (orgId && code) {
      fnGetEducation()
    }
  }, [orgId, code])

  const fnGetEducation = async () => {
    const result = await getEducationAPI({ orgId, code })
    if (!result) return
    if (result.status) {
      setDataTable(result.result)
    }
  }
  const roleId = useSelector((state) => state.roleReducer.role)
  const profileId = useSelector((state) => state.loginReducer.profile)
  const roles = CheckUserAdmin(profileId.roles, roleId)
  const [dataAe, setDataAe] = useState([])
  const [searchAE, setSearchAE] = useDebounce('', 1000)
  const codeAE = UserecruitsAe(searchAE)

  const fnSearchAE = async (aeNo) => {
    const param = { orgId, aeNo }
    const resp = await RecruitsEducationsAPI(param)
    if (!resp) return
    if (resp.status) {
      const newTable =
        resp.result.length > 0
          ? resp.result.map((d) => {
              return {
                id: uuidv4(),
                education_level: d.education_level,
                isEducationLevel: !!d.education_level,
                eduTypeId: d.education_level_id,
                eduName: d.education_name,
                isEduName: !!d.education_name,
                adYear: d.admission_year,
                isAdYear: !!d.admission_year,
                gradYear: d.graduation_year,
                isGradYear: !!d.graduation_year,
                eduBg: d.edu_bg,
                isEduBg: !!d.edu_bg,
                major: d.major,
                isMajor: !!d.major,
                grade: d.grade,
                isGrade: !!d.grade
              }
            })
          : []
      setDataAe(newTable)
      setShowAE(true)
    }
  }

  return (
    <Row>
      <Col xl={12} className="d-flex justify-content-between mb-3">
        <span className="my-auto text-primary">Education History</span>

        {roles?.status_id === 1 && (
          <div className="d-flex">
            <div style={{ minWidth: 200 }} className="me-3">
              <Autocomplete
                isClearable={true}
                height={'32px'}
                placeholder={'Search AE No.'}
                options={codeAE}
                onInputChange={(data) => {
                  setSearchAE(data.toUpperCase())
                }}
                onChange={(data) => {
                  if (data) {
                    fnSearchAE(data.value)
                  }
                }}
              />
            </div>

            <Button
              style={{ minWidth: '210px', maxHeight: '35px' }}
              onClick={() => setShowCreate(true)}
            >
              <BsPlusLg /> Add Education History
            </Button>
          </div>
        )}
      </Col>
      <Col className="">
        <Table responsive bordered hover className="mb-0">
          <thead className="bg-hrms text-white ">
            <tr>
              <th
                className="fw-normal small align-middle text-center"
                rowSpan={2}
              >
                #
              </th>
              <th className="fw-normal small align-middle " rowSpan={2}>
                Education Degree
              </th>

              <th className="fw-normal small align-middle " rowSpan={2}>
                Institution Name
              </th>

              <th
                className="fw-normal small align-middle text-center"
                colSpan={2}
              >
                Education Year
              </th>
              <th className="fw-normal small align-middle" rowSpan={2}>
                Educational Qualification
              </th>
              <th
                className="fw-normal small align-middle text-center"
                rowSpan={2}
              >
                Faculty
              </th>
              <th className="fw-normal small align-middle" rowSpan={2}>
                Major
              </th>

              <th className="fw-normal small align-middle" rowSpan={2}>
                Grade
              </th>
              <th
                className="fw-normal small align-middle text-center"
                rowSpan={2}
              >
                <div> Transcript</div>
                <span className="fw-light" style={{ fontSize: '12px' }}>
                  File{' '}
                </span>
                <span
                  className="fw-light small align-middle"
                  style={{ fontSize: '12px' }}
                >
                  (PDF Max 8 MB)
                </span>
              </th>
              <th
                className="fw-normal small align-middle text-center"
                rowSpan={2}
              >
                <div> Degree Certificate</div>
                <span className="fw-light" style={{ fontSize: '12px' }}>
                  File{' '}
                </span>
                <span
                  className="fw-light small align-middle "
                  style={{ fontSize: '12px' }}
                >
                  (PDF Max 8 MB)
                </span>
              </th>
              <th
                className="fw-normal small align-middle text-center"
                rowSpan={2}
              >
                Edit
              </th>
            </tr>
            <tr>
              <th className="fw-normal small align-middle text-center">From</th>
              <th className="fw-normal small align-middle text-center">To</th>
            </tr>
          </thead>
          <tbody>
            {dataTable.length > 0 ? (
              dataTable.map((d, i) => (
                <tr key={i} className="fw-light font-small-2 pointer-event">
                  <td>{i + 1}</td>
                  <td>{d.education}</td>
                  <td>{d.edu_name}</td>
                  <td className="text-center">{d.admission_year}</td>
                  <td className="text-center">{d.graduation_year}</td>

                  <td>{d?.qualification ?? '-'}</td>
                  <td>{d.edu_bg}</td>

                  <td>{d.major}</td>
                  <td>{d.grade}</td>
                  {d.files.length > 0 ? (
                    d.files.map((f) => (
                      <>
                        <td className="text-center">
                          <FileEducationTablePIM
                            educationId={d.id}
                            isFile={f.isFile}
                            idcode={{ orgId, code }}
                            fnData={fnGetEducation}
                            docTypeId={f.doc_type_id}
                          />
                        </td>
                      </>
                    ))
                  ) : (
                    <></>
                  )}
                  <td className="text-center">
                    <span className="me-2">
                      <Image
                        className=" pointer-event"
                        style={{
                          width: '20px'
                        }}
                        onClick={() => {
                          if (roles?.status_id === 1) {
                            setDetailTable(d)
                            setShowEdite(true)
                          }
                        }}
                        src={iconEdit}
                      />{' '}
                    </span>
                  </td>
                </tr>
              ))
            ) : (
              <tr className="fw-light ">
                <td colSpan={12} className="text-center">
                  - No data -
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </Col>

      {showCreate ? (
        <CreateEducationHistory
          param={{ orgId, code }}
          setIsSave={setIsSave}
          showCreate={showCreate}
          isSave={isSave}
          fnGetWorks={fnGetEducation}
          setShowCreate={setShowCreate}
          // educationTypes={educationTypes}
        />
      ) : (
        <></>
      )}
      {showEdite ? (
        <EditEducationHistory
          detail={detailTable}
          param={{ orgId, code }}
          setIsSave={setIsSave}
          showCreate={showEdite}
          isSave={isSave}
          fnGetWorks={fnGetEducation}
          setShowCreate={setShowEdite}
          // educationTypes={educationTypes}
        />
      ) : (
        <></>
      )}

      {showAE && (
        <ModalAddAeEducation
          showAE={showAE}
          setShowAE={setShowAE}
          dataAe={dataAe}
          setDataAe={setDataAe}
          isSave={isSave}
          setIsSave={setIsSave}
          fnGetEducation={fnGetEducation}
          orgId={orgId}
          code={code}
        />
      )}
    </Row>
  )
}

export default EducationHistory
